const questionFields = {
    RD: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            'answerLibrary',
            'optionalFeatures',
            {
                optionEditor: {
                    optionMenu: [
                        'allowEdit',
                        'headerRow',
                        'isNonReporting',
                        'hasOptionOther',
                        'otherPiping',
                        'metrics',
                        'optionOtherIsMandatory',
                        'skipLogic',
                        'isLocked',
                        'delete',
                        'isHidden',
                    ],
                    sortBy: ['isRandomized', 'isAlphaSort'],
                    buttons: ['other'],
                },
            },
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isBenchmarked',
                    'isFilterBenchmarked',
                    'isEditable',
                    'dspYourScore',
                ],
            },
            'questionCategory',
        ],
        advanced: [
            'noColumns',
            'display',
            'npsStyle',
            'enableQuadrant',
            'graphType',
            'enableMetrics',
            'headerRows',
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    CH: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            {
                optionEditor: {
                    optionMenu: [
                        'allowEdit',
                        'headerRow',
                        'isExclusive',
                        'isNonReporting',
                        'hasOptionOther',
                        'otherPiping',
                        'metrics',
                        'optionOtherIsMandatory',
                        'skipLogic',
                        'isLocked',
                        'delete',
                        'isHidden',
                    ],
                    sortBy: ['isRandomized', 'isAlphaSort'],
                    buttons: ['other', 'none'],
                },
            },
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isBenchmarked',
                    'isFilterBenchmarked',
                    'isEditable',
                ],
            },
            'questionCategory',
        ],
        advanced: [
            'noColumns',
            'display',
            'graphType',
            'minNumOptions',
            'maxNumOptions',
            'enableMetrics',
            'headerRows',
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    TB: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            {
                rowWrap: [
                    'rowOptionalFeatures',
                    {
                        rowOptionEditor: {
                            optionMenu: [
                                'allowEdit',
                                'headerRow',
                                'skipLogic',
                                'isLocked',
                                'delete',
                                'isHidden',
                            ],
                            sortBy: ['isRandomized', 'isAlphaSort'],
                        },
                    },
                ],
            },
            {
                colWrap: [
                    'answerLibrary',
                    'colOptionalFeatures',
                    {
                        colOptionEditor: {
                            optionMenu: [
                                'allowEdit',
                                'skipLogic',
                                'isLocked',
                                'fieldType',
                                'optionExclusive',
                                'optionNumeric',
                                'delete',
                                'isHidden',
                            ],
                            sortBy: ['isRandomized', 'isAlphaSort'],
                        },
                    },
                ],
            },
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isBenchmarked',
                    'isFilterBenchmarked',
                    'isEditable',
                ],
            },
            'questionCategory',
        ],
        advanced: [
            'displayOptions',
            'enableQuadrant',
            'graphType',
            'headerRows',
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    SB: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            'answerLibrary',
            'optionalFeatures',
            {
                optionEditor: {
                    optionMenu: [
                        'allowEdit',
                        'headerRow',
                        'isNonReporting',
                        'skipLogic',
                        'isLocked',
                        'delete',
                        'isHidden',
                    ],
                    sortBy: ['isRandomized', 'isAlphaSort'],
                },
            },
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isBenchmarked',
                    'isFilterBenchmarked',
                    'isEditable',
                    'dspYourScore',
                ],
            },
            'questionCategory',
        ],
        advanced: [
            'graphType',
            'enableQuadrant',
            'headerRows',
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    TX: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isEditable',
                ],
            },
            'questionCategory',
        ],
        advanced: [
            'characterLimit',
            'validation',
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    TA: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isEditable',
                ],
            },
            'questionCategory',
        ],
        advanced: [
            'characterLimit',
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    SG: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            {
                rowWrap: [
                    'rowOptionalFeatures',
                    {
                        rowOptionEditor: {
                            optionMenu: [
                                'allowEdit',
                                'skipLogic',
                                'isLocked',
                                'delete',
                                'isHidden',
                            ],
                        },
                    },
                ],
            },
            {
                colWrap: [
                    'colOptionalFeatures',
                    'colOptionEditor',
                ],
            },
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isBenchmarked',
                    'isFilterBenchmarked',
                    'isEditable',
                ],
            },
            'questionCategory',
        ],
        advanced: [
            'display',
            'enableQuadrant',
            'graphType',
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    OD: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            {
                optionEditor: {
                    optionMenu: [
                        'allowEdit',
                        'skipLogic',
                        'isLocked',
                        'delete',
                        'isHidden',
                    ],
                    sortBy: ['isRandomized', 'isAlphaSort'],
                },
            },
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isEditable',
                ],
            },
            'questionCategory',
        ],
        advanced: [
            'maxRankedItems',
            'graphType',
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    PC: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            {
                optionEditor: {
                    optionMenu: [
                        'allowEdit',
                        'headerRow',
                        'skipLogic',
                        'isLocked',
                        'delete',
                        'isHidden',
                    ],
                    sortBy: ['isRandomized', 'isAlphaSort'],
                },
            },
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isBenchmarked',
                    'isFilterBenchmarked',
                    'isEditable',
                ],
            },
            'questionCategory',
            'format',
            'maxNum',
            'sliderSettings',
        ],
        advanced: [
            'sliderSettingsAdvanced',
            'enableQuadrant',
            'inheritMaxValueQue',
            'inheritMaxValueOpt',
            'sliderLabels',
            'minNum',
            'graphType',
            'headerRows',
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    I: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isBenchmarked',
                    'isFilterBenchmarked',
                    'isEditable',
                ],
            },
            'questionCategory',
            'minNum',
            'maxNum',
        ],
        advanced: [
            'graphType',
            'enableQuadrant',
            'switchInfoOptions',
            'switchFormat',
            'switchLeftVal',
            'switchRightVal',
            'infoText',
            'valueBefore',
            'valueAfter',
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    RT: {
        newQuestion: [
            'questionTypeSelect',
        ],
        standard: [
            'questionTypeSelect',
        ],
        advanced: [
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    ST: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'stQuestionText',
        ],
        advanced: [
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    UV: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'questionShortNameAndType',
            'questionText',
            {
                optionEditor: {
                    optionMenu: [
                        'allowEdit',
                        'delete',
                        'isHidden',
                    ],
                },
            },
        ],
        advanced: [
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    TL: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            {
                optionEditor: {
                    optionMenu: [
                        'allowEdit',
                        'skipLogic',
                        'isLocked',
                        'delete',
                        'isHidden',
                    ],
                    sortBy: ['isRandomized', 'isAlphaSort'],
                },
            },
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isEditable',
                ],
            },
            'questionCategory',
        ],
        advanced: [
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    FM: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            {
                optionEditor: {
                    optionMenu: [
                        // 'skipLogic',
                        'delete',
                        'isHidden',
                        'editSubQue',
                        'subQueMandatory',
                    ],
                },
            },
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isEditable',
                ],
            },
            'questionCategory',
        ],
        advanced: [
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
        editSubQue: {
            TX: [
                'questionShortName',
                'characterLimit',
                'validation',
                'switchInfoOptions',
                'switchFormat',
                'switchLeftVal',
                'switchRightVal',
                'switchNonRequiredOption',
                'infoText',
            ],
            SB: [
                'questionShortName',
                'optionalFeatures',
                {
                    optionEditor: {
                        optionMenu: [
                            'allowEdit',
                            'isNonReporting',
                            'skipLogic',
                            'isLocked',
                            'delete',
                            'isHidden',
                        ],
                        sortBy: ['isRandomized', 'isAlphaSort'],
                    },
                },
                'switchInfoOptions',
                'switchFormat',
                'switchLeftVal',
                'switchRightVal',
                'switchNonRequiredOption',
                'infoText',
            ],
            I: [
                'questionShortName',
                'minNum',
                'maxNum',
                'valueBefore',
                'valueAfter',
                'switchInfoOptions',
                'switchFormat',
                'switchLeftVal',
                'switchRightVal',
                'switchNonRequiredOption',
                'infoText',
            ],
            DT: [
                'questionShortName',
                'dateType',
                'minDate',
                'maxDate',
                'startDateText',
                'endDateText',
                'switchInfoOptions',
                'switchFormat',
                'switchLeftVal',
                'switchRightVal',
                'switchNonRequiredOption',
                'infoText',
            ],
        },
    },
    DT: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            'dateType',
            'startDateText',
            'endDateText',
            'minDate',
            'maxDate',
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isEditable',
                ],
            },
            'questionCategory',
        ],
        advanced: [
            'textAbove',
            'textBelow',
            'customCss',
            'template',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
    },
    NF: {
        newQuestion: [
            'questionShortName',
            'questionTypeSelect',
        ],
        standard: [
            'language',
            'historicalData',
            'questionShortNameAndType',
            'questionText',
            'instructionText',
            {
                optionEditor: {
                    optionMenu: [
                        // 'skipLogic',
                        // 'isLocked',
                        'delete',
                        'isHidden',
                        'editSubQue',
                        'subQueMandatory',
                    ],
                },
            },
            {
                questionLibraryOptions: [
                    'isActive',
                    'isglobal',
                    'isNewGlobal',
                    'isBenchmarked',
                    'isFilterBenchmarked',
                    'isEditable',
                    'dspYourScore',
                    'isCurrency',
                ],
            },
            'questionCategory',
        ],
        advanced: [
            'enableQuadrantNF',
            'textAbove',
            'textBelow',
            'customCss',
            'template',
            'addSwitchEstimateAllSubQue',
        ],
        translate: ['translate'],
        productTypes: [
            'proAcc',
            'productType',
        ],
        editSubQue: {
            I: [
                'questionShortName',
                'chartDisplayText',
                'minNum',
                'maxNum',
                'NFswitchInfoOptions',
                'infoText',
            ],
        },
    },
}

export default questionFields
